import { SiDocsdotrs } from "react-icons/si";
import { FaReact } from "react-icons/fa";
import { AiFillHtml5 } from "react-icons/ai";
import { DiCss3 } from "react-icons/di";
import { DiJavascript } from "react-icons/di";
import { DiMongodb } from "react-icons/di";
import { IoLogoNodejs } from "react-icons/io";
import { TbBrandTypescript } from "react-icons/tb";

import "./Skills.css";

const Skills = () => {
  return (
    <div className="pages-page-main">
      <div className="pages-inner-content">
        <div
          className="pages-heading-div"
          data-aos="fade-up"
          data-aos-offset="0"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
        >
          <SiDocsdotrs className="pages-page-icon" />
          <span className="pages-introduce">skills</span>
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="0"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
          className="about-introduction-heading"
        >
          My
          <span className="colored-heading"> Advantages</span>
        </div>
        <div className="skills-main-container">
          <div
            className="skills-main-div"
            data-aos="fade-down-right"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="skills-name-inner">
              <AiFillHtml5 className="skills-image" />
              <div className="skills-percentage">92%</div>
            </div>
            <div className="skill-name">HTML</div>
          </div>
          <div
            className="skills-main-div"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="skills-name-inner">
              <DiCss3 className="skills-image" />
              <div className="skills-percentage">85%</div>
            </div>
            <div className="skill-name">CSS</div>
          </div>
          <div
            className="skills-main-div"
            data-aos="fade-down"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="skills-name-inner">
              <DiJavascript className="skills-image" />
              <div className="skills-percentage">65%</div>
            </div>
            <div className="skill-name">Javascript</div>
          </div>
          <div
            className="skills-main-div"
            data-aos="fade-left"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="skills-name-inner">
              <FaReact className="skills-image" />
              <div className="skills-percentage">85%</div>
            </div>
            <div className="skill-name">React js</div>
          </div>
          <div
            className="skills-main-div"
            data-aos="fade-up-right"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="skills-name-inner">
              <IoLogoNodejs className="skills-image" />
              <div className="skills-percentage">55%</div>
            </div>
            <div className="skill-name">Node js</div>
          </div>
          <div
            className="skills-main-div"
            data-aos="fade-down"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="skills-name-inner">
              <TbBrandTypescript className="skills-image" />
              <div className="skills-percentage">65%</div>
            </div>
            <div className="skill-name">Typescript</div>
          </div>
          <div
            className="skills-main-div"
            data-aos="fade-left"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="skills-name-inner">
              <DiMongodb className="skills-image" />
              <div className="skills-percentage">70%</div>
            </div>
            <div className="skill-name">Mongodb</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Skills;
